<template>
	<div>
		<div slot="modal-body">
			<!--<b-row>-->

			<!--<b-col>-->
			<!--<b-form-group size="sm"-->
			<!--breakpoint="lg"-->
			<!--label-size="sm"-->
			<!--label-cols="4"-->
			<!--:label="lostItem.itemName	">-->
			<b-row>
				<table class="table table-bordered mt-3" style="margin-right: 10px;margin-left: 10px;">
					<thead>
					<tr>
						<th style="width: 30px;text-align: center">№</th>
						<th>{{$t('sidebar.warehouse-management.products')}}</th>
						<th colspan="2">{{$t('goods.amount')}}</th>
						<!--<th style="width: 230px;">Количество</th>-->
					</tr>
					</thead>
					<tr v-for="lostItem,index in items" cols="12">
						<td style="text-align: center">
							{{ index + 1 }}
						</td>
						<td>{{lostItem.name}}/ <strong>{{ lostItem.artikul}}</strong>/{{lostItem.color}}/{{lostItem.size}}
							<strong>{{lostItem.barcode}}</strong></td>
						<!--<td colspan="2">-->
						<!--{{ lostItem.count }} {{lostItem.unit}}-->
						<!--</td>-->
						<td>
							<b-col>
								<b-input-group size="sm">
									<b-form-input v-model="lostItem.count"

												  size="sm" autocomplete="off" type="number"></b-form-input>
									<b-input-group-addon>
										<b-button size="sm" disabled>
											{{ lostItem.unitName }}
										</b-button>
									</b-input-group-addon>
								</b-input-group>
							</b-col>
						</td>
					</tr>
				</table>

			</b-row>
			<!--</b-form-group>-->
			<!--</b-col>-->
			<!--</b-row>-->
		</div>

		<div slot="modal-footer">
			<b-button
				variant="success"
				size="sm"
				class="float-right ml-2"
				@click="submitReturn"
			>
				{{$t('save')}}
			</b-button>

			<b-button
				variant="primary"
				size="sm"
				class="float-right"
				@click="cancelReturn"
			>
				{{$t('cancel')}}
			</b-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: "BarcodeModal",
		data() {
			return {
				count: 0,
			}
		},
		props: {
			items: {
				type: Array,
			}
		},
		methods: {
			cancelReturn() {
				this.$emit('cancel');
			},
			submitReturn() {
				this.$emit('ok', this.items);
			},

		}
	}
</script>

<style scoped>

</style>
